import {
  Button,
  Grid,
  Link,
  Switch,
  Typography,
  WithStyles,
  withStyles,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
} from "@material-ui/core";
import React, { Component, Ref } from "react";
import { connect } from "react-redux";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import { getContentSubType } from "../../test-template/actions/testTemplateActions";
import _, { filter, values } from "lodash";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { styles } from "../../course/styling/CreateCourse";
import TopNav from "../components/TopNav";
import CourseFiltersPanel from "../components/CourseFiltersPanel";
import CourseCardsList from "../components/CourseCardsList";
import MyPATLandingContainer from "../../common/MyPATLandingContainer";
import courseService from "../../course/services/courseService";
import { userStyles } from "../../content-request/styles";
import ContentPagination from "../../mylibrary/components/ContentPagination";
import { bindActionCreators } from "redux";
import { getActiveGoals, getBulkReport } from "../actions/courseManagementActions";
import { Goal } from "../types/interfaces/Goal";
import NoContent from "../components/NoContent";
import { contentManagementAction } from "../reducers/contentMangementData";
import moment from "moment";
import { createErrorSheet } from "../helpers/helpers";
import { COURSES_TAB, COURSE_REQUEST_TABS, FILTERS } from '../Constants/constants';
import cx from "classnames"
import { MyPATDropdown } from '../../common';
import { REQUEST_STATUS } from '../types/enums/RequestStatus';
import { getQueryParams, updateQueryParams } from '../../../utils';

// @ts-ignore
const reactCreateRef = React.createRef;
const requestTabs = Object.values(REQUEST_STATUS);

interface RouteParams {}
interface CourseManagementContainerProps extends WithStyles<typeof userStyles> {
  getActiveGoals: Function;
  getBulkReport: Function;
  goals: Goal[];
  resetAllState: Function;
  setCoursePackageList: Function;
  bulkReport: any;
  bulkReportCount: number;
  history: any;
}
interface CourseManagementContainerState {
  totalCount: number;
  filters: any;
  packageResponse: any;
  loading: boolean;
  activeTab: string;
  currentReportPageNo: number;
  currentTab: any;
  resetFilterRef:any;
  updateFilterRef: any;
  firstTimeCourseRequest: boolean;
  centerList: any[],
  searchCenterList: any[],
  selectedCentreList: any[],
  countForRequestStatus: any,
  firstTimeRequestFilter: boolean
}
class CourseManagementContainer extends Component<
  CourseManagementContainerProps,
  CourseManagementContainerState
> {
  constructor(props: CourseManagementContainerProps) {
    super(props);
    this.state = {
      totalCount: 0,
      filters: {},
      packageResponse: {},
      loading: false,
      activeTab: "Courses",
      currentReportPageNo: 1,
      currentTab: 0,
      resetFilterRef: reactCreateRef(),
      updateFilterRef: reactCreateRef(),
      firstTimeCourseRequest: true,
      centerList: [],
      searchCenterList: [],
      selectedCentreList: [],
      countForRequestStatus: this.getDefaultRequestCount(),
      firstTimeRequestFilter: true
    };
  }
  multipleFilter = ['statusValue', 'userType', 'packageType', 'goals', 'courseType'];

  getDefaultRequestCount() {
    return ({
      awaiting: 0,
      approved: 0,
      rejected: 0
    });
  }

  componentDidMount() {
    this.getPackageData();
    this.props.resetAllState();
    this.props.getBulkReport(1);
    this.getCenterList();
    const activeTab = getQueryParams(this.props.history.location.search, 'requestStatus');
    const activeTabIndex = Object.values(REQUEST_STATUS).findIndex((tabs) => tabs === activeTab);
    if (activeTabIndex !== -1) {
      this.handleTabClick(activeTabIndex);
    }
  }
  getCenterList = () => {
    courseService.fetchCenterList().then((res: any) => {
      const centerList = res.centers;
      if (centerList && centerList.length) {
        this.setState({
          centerList,
          searchCenterList: centerList,
        });
      }
    });
  }
  getPackageData = () => {
    const reqParams = { pagination: true, currentPageNo: 1, pageSize: 10 };
    this.props.getActiveGoals();
    this.fetchAllData(reqParams);
  };
  setFilters = (filters: any[]) => {
    const newFilter: any = {};
    filters.forEach((filter: any) => {
      let key = "";
      if (filter.hasOwnProperty("variant")) {
        key = filter.values.key;
        let isMultiple = this.multipleFilter.includes(key);
        newFilter[key] = {
          isMultiple: isMultiple,
          standardValues: filter.values.values,
          values: isMultiple ? [] : "",
        };
        key = filter.variant.key;
        isMultiple = this.multipleFilter.includes(key);
        newFilter[key] = {
          isMultiple: isMultiple,
          standardValues: filter.variant.values,
          values: isMultiple ? [] : "",
        };
      } else {
        key = filter.key;
        const isMultiple = this.multipleFilter.includes(key);
        newFilter[key] = {
          isMultiple: isMultiple,
          standardValues: filter.values,
          values: isMultiple ? [] : "",
        };
        if (key === "dateType") {
          newFilter["startDate"] = { isMultiple: false, values: "" };
          newFilter["endDate"] = { isMultiple: false, values: "" };
        }
      }
      if(key==="statusType"){
        newFilter[key].values='master';
      }
    });
    newFilter["goals"] = {
      isMultiple: true,
      values: [],
      standardValues: [],
    };
    if (requestTabs.length) {
      newFilter.requestStatus = {
        values: requestTabs[0],
        isMultiple: false,
      };
    }
    newFilter.centerId = {
      values: [],
      isMultiple: true,
    };
    newFilter.searchQuery = {
      values: '',
      isMultiple: false
    };
    this.setState({ filters: newFilter });
  };
  fetchAllData = async (reqParams: any, requestList?: boolean) => {
    const {
      pagination,
      currentPageNo,
      pageSize,
      searchQuery,
      filters,
    } = reqParams;
    const newParams: any = {};
    const { activeTab } = this.state;
    if (pagination) {
      newParams.pagination = pagination;
      newParams.pageNumber = currentPageNo;
      newParams.pageSize = pageSize;
    }
    if (searchQuery && searchQuery.length >= 3) {
      newParams.searchQuery = searchQuery;
    }
    if (filters) {
      const filtersKeys = Object.keys(filters);
      for (let key of filtersKeys) {
        const values = filters[key].values;
        if (values.length > 0) {
          if (key === "dateType") {
            const startDate = filters["startDate"].values;
            const endDate = filters["endDate"].values;
            if (startDate.length === 0 || endDate.length === 0) {
              continue;
            }
          }
          if (key === "statusType") {
            const statusValue = filters["statusValue"].values;
            if (statusValue.length == 0) {
              continue;
            }
          }
          if (filters[key].isMultiple) {
            newParams[key] = values.join(",");
          } else {
            newParams[key] = values;
          }
        }
      }
    }
    const courseCardRequest = activeTab === COURSES_TAB.COURSE_CHANGE_REQUEST || requestList;
    return courseService.fetchPackageList(newParams, courseCardRequest).then((res: any) => {
      this.fetchFilters(res);
      if (res.hasOwnProperty("totalCount")) {
        this.setState({
          totalCount: res.totalCount,
          packageResponse: res,
          loading: true,
        });
        let packages = [];
        if (courseCardRequest) {
          packages = res.packageChangeRequestList;
          const countForRequestStatus: any = this.getDefaultRequestCount();
          res.statusWiseCount.forEach((status: any) => {
            countForRequestStatus[status._id] = status.count;
          });
          this.setState({ countForRequestStatus, packageResponse: { packages } });
        } else {
          packages = res.packages;
        }
        this.props.setCoursePackageList(packages);
      }
      return res;
    });
  };
  fetchFilters = (res: any) => {
    if (res.hasOwnProperty("filters") && _.isEmpty(this.state.filters)) {
      this.setFilters(res.filters);
    }
    const { firstTimeRequestFilter, activeTab } = this.state;
    const filters = res.filters;
    const filterForCourseRequest = filters && firstTimeRequestFilter && (activeTab === COURSES_TAB.COURSE_CHANGE_REQUEST);
    if (filterForCourseRequest) {
      this.setState({ firstTimeRequestFilter: false });
      this.setFilters(filters);
    }
    
  };
  isFiltersEmpty=(filters:any)=>{
    const filterKeys=Object.keys(filters);
      for(let key of filterKeys){
       if(key==='statusType'){
          continue ; 
        } 
         const{values}=filters[key];
         if(!_.isEmpty(values)){
           return false;
         }  
      }
     return true; 
  }

  setActiveTabInParent(tab: string) {
    if (tab === this.state.activeTab) {
      return;
    }

    if (tab === COURSES_TAB.BULK_IMPORT) {
      return this.props.getBulkReport(1);
    } else {
      if (this.state.firstTimeCourseRequest) {
        this.state.updateFilterRef.current(FILTERS.REQUEST_TYPE, requestTabs[0]);
      }
      if (this.state.resetFilterRef && this.state.resetFilterRef.current) {
        this.state.resetFilterRef.current(tab);
      }
    }
    updateQueryParams('activeTab', tab);
    this.setState({
      activeTab: tab,
      currentReportPageNo: 1,
      firstTimeCourseRequest: false
    })
  }

  getResponseSheet(id: string, type: string) {
    courseService.getResponseSheet(id)
    .then((res: any) => {
        if (res.statusCode == 200) {
            if(res.responseObject.detailedReport && type === 'bulkImportScheduledTests'){
                const data:any[]=[];
                res.responseObject.detailedReport.forEach((err:any)=>{
                  const obj:any={};
                  for(let key in err){
                    if(key === "sku" || key === "reasons" || key === "status" || key === "mainTestCount" || key === "milestoneTestCount" ) {
                      obj["sku".toUpperCase()] = err["sku"];
                      obj["mainTestCount".toUpperCase()] = err["mainTestCount"] ? err["mainTestCount"] : 0;
                      obj["milestoneTestCount".toUpperCase()] = err["milestoneTestCount"] ? err["milestoneTestCount"] : 0;
                      obj["status".toUpperCase()] = err["status"];
                      obj["reasons".toUpperCase()] = err["reasons"].join(",");
                    }
                  }
                  data.push(obj);
                })
                if(data.length==res.responseObject.detailedReport.length){
                    createErrorSheet(data,'Response_Sheet.xlsx');
                }
            } else if(res.responseObject.detailedReport && type === 'mapScheduledTests') {
              const data:any[]=[];
              res.responseObject.detailedReport.forEach((err:any)=>{
                const obj:any={};
                for(let key in err){
                  if(key === "sku" || key === "reasons" || key === "primaryTestName" || key === "testId" || key === "status" ) {
                    obj["primary test name".toUpperCase()] = err["primaryTestName"];
                    obj["sku".toUpperCase()] = err["sku"];
                    obj["test id".toUpperCase()] = err["testId"] ? err["testId"] : '';
                    obj["status".toUpperCase()] = err["status"];
                    if(err["reasons"].length > 0) {
                      obj["remarks".toUpperCase()] = err["reasons"].join(",");

                    }
                  }
                }
                data.push(obj);
              })
              if(data.length==res.responseObject.detailedReport.length){
                  createErrorSheet(data,'Response_Sheet.xlsx');
              }
            }else if(res.responseObject.detailedReport && type === 'bulkAddContent'){
              const data:any[]=[];
              res.responseObject.detailedReport.forEach((err:any)=>{
                const obj:any={};
                for(let key in err){
                  if(key === "sku" || key === "reasons" || key === "testName" || key === "selectedContent" || key === "status" ) {
                   obj["sku".toUpperCase()] = err["sku"];
                    obj["selectedContent".toUpperCase()] = err["selectedContent"];
                    obj["addedContent".toUpperCase()] = err["addedContent"];
                    obj["status".toUpperCase()] = err["status"];
                    if(err["reasons"].length > 0) {
                      obj["error".toUpperCase()] = err["reasons"].join(",");

                    }
                  }
                }
                data.push(obj);
              })
              if(data.length==res.responseObject.detailedReport.length){
                  createErrorSheet(data,'Response_Sheet.xlsx');
              }
            }else if(res.responseObject.detailedReport && type === 'bulkEditContent'){
              const data:any[]=[];
              res.responseObject.detailedReport.forEach((err:any)=>{
                const obj:any={};
                for(let key in err){
                  if(key === "sku" || key === "reasons" || key === "testName" || key === "selectedContent" || key === "status" ) {
                   obj["sku".toUpperCase()] = err["sku"];
                   obj["status".toUpperCase()] = err["status"];
                    if(err["reasons"].length > 0) {
                      obj["reasons".toUpperCase()] = err["reasons"].join(",");

                    }
                  }
                }
                data.push(obj);
              })
              if(data.length==res.responseObject.detailedReport.length){
                  createErrorSheet(data,'Response_Sheet.xlsx');
              }
            }
            else if(res.responseObject.detailedReport && type === 'bulkRemoveContent'){
              const data:any[]=[];
              res.responseObject.detailedReport.forEach((err:any)=>{
                const obj:any={};
                for(let key in err){
                  if(key === "sku" || key === "reasons" || key === "testName" || key === "selectedContent" || key === "status" ) {
                   obj["sku".toUpperCase()] = err["sku"];
                    obj["selectedContent".toUpperCase()] = err["selectedContent"];
                    obj["removedContent".toUpperCase()] = err["removedContent"];
                    obj["status".toUpperCase()] = err["status"];
                    if(err["reasons"].length > 0) {
                      obj["reasons".toUpperCase()] = err["reasons"].join(",");

                    }
                  }
                }
                data.push(obj);
              })
              if(data.length==res.responseObject.detailedReport.length){
                  createErrorSheet(data,'Response_Sheet.xlsx');
              }
            }
        }
    })
  }
  onPageChangeReport(page: number) {
    this.setState({currentReportPageNo: page})
    this.props.getBulkReport(page);
  }
  getOperationType(type: string) {
    switch(type) {
      case 'bulkImportScheduledTests' : return 'Bulk Import Scheduled Tests';
      case 'mapScheduledTests': return'Map Scheduled Tests';
      case 'bulkAddContent': return 'Bulk Add Content';
      case 'bulkEditContent': return 'Bulk Edit Content';
      case 'bulkRemoveContent': return 'Bulk Remove Content';
    }

  }

  handleSearch = (searchText: string) => {
    const { updateFilterRef } = this.state;
    if (updateFilterRef) {
      updateFilterRef.current(FILTERS.SEARCH_QUERY, searchText);
    }
  }
  handleSelectedCenter = (selectedCentreList: string[]) => {
    const { updateFilterRef } = this.state;
    if (updateFilterRef) {
      updateFilterRef.current(FILTERS.CENTER_IDS, selectedCentreList.join(','));
    }
  }

  handleCenterSearch = (searchCenter: string) => {
    const { centerList } = this.state;
    let searchCenterList = [...centerList]
    searchCenter = searchCenter.toLocaleLowerCase();
    const MIN_LENGTH = 2;
    if (searchCenter.length > MIN_LENGTH) {
      searchCenterList = centerList.filter(center =>
        center && (center.name || '').toLocaleLowerCase().
          includes(searchCenter));
    }
    this.setState({ searchCenterList });
  }

  handleTabClick = (tabIndex: number) => {
    const { currentTab, updateFilterRef } = this.state
    if (tabIndex !== currentTab) {
      this.setState({ currentTab: tabIndex }, () => {
        if (updateFilterRef && updateFilterRef.current) {
          updateFilterRef.current(FILTERS.REQUEST_TYPE, requestTabs[tabIndex]);
          updateQueryParams('requestStatus', requestTabs[tabIndex]);
        }
      });
    }
  };

  getRequestStatusCount = (tabIndex: number) => {
    const { countForRequestStatus } = this.state;
    let count = 0;
    switch (tabIndex) {
      case 0:
        count = countForRequestStatus.awaiting;
        break;
      case 1:
        count = countForRequestStatus.approved;
        break;
      case 2:
        count = countForRequestStatus.rejected;
        break;
      case 3:
        count = countForRequestStatus.closed;
        break;
      default: count = 0;
    }

    return count || 0;
  }

  render() {
    const { loading, activeTab, currentReportPageNo, searchCenterList } = this.state;
    const { bulkReport, bulkReportCount } = this.props;
    return (
      <>
        {loading && (
          <MyPATLandingContainer
            loading
            fetchAllData={this.fetchAllData}
            filters={this.state.filters}
            data={this.state.packageResponse}
            resetFilter={this.state.resetFilterRef}
            updateFilter={this.state.updateFilterRef}
            totalCount={this.state.totalCount}
          >
            {({
              data,
              loading,
              onPageChange,
              onSearchQueryChange,
              searchQuery,
              currentPageNo,
              filters,
              handleFilterChange,
              totalCount
            }) => {
              const { packages, totalPages, pageNumber } = data;
              const { classes } = this.props;
              const activeChangeRequestTab = activeTab === COURSES_TAB.COURSE_CHANGE_REQUEST;
              return (
                <div>
                  <Grid container>
                    <TopNav
                      bulkReport={bulkReport}
                      setActiveTabInParent={(e: string) =>
                        this.setActiveTabInParent(e)
                      }
                      hideCreateBttn={
                        packages &&
                        packages.length == 0 &&
                        searchQuery.length === 0 &&
                        this.isFiltersEmpty(filters)
                      }
                    />
                  </Grid>
                  <Grid container spacing={16} justify="flex-end">
                    <>
                      {(activeTab === COURSES_TAB.COURSES || activeChangeRequestTab) && (
                        <>
                          <Grid item xs={3}>
                            <Grid
                              className={[
                                classes.sideContainer,
                                classes.mt72,
                              ].join(" ")}
                            >
                              {!_.isEmpty(filters) && (
                                <CourseFiltersPanel
                                  filters={filters}
                                  onchange={handleFilterChange}
                                />
                              )}
                            </Grid>
                          </Grid>
                          <Grid item xs={9}>
                            <Grid
                              className={classes.noDataContainer}
                            >
                              {((packages &&
                                packages.length > 0) ||
                                (searchQuery &&
                                  searchQuery.length > 0) ||
                                !this.isFiltersEmpty(
                                  filters
                                )) && (
                                <Grid
                                  container
                                  justify="space-between"
                                  alignItems="center"
                                  spacing={16}
                                >
                                  <Grid item>
                                    <div className={classes.searchSelectDropdown}>
                                      <Grid
                                        className={
                                          classes.searchContainer
                                        }
                                      >
                                        <img src="/assets/svg/contentRequest/search-icon.svg" alt="Search" />
                                        <input
                                          type="text"
                                          value={searchQuery}
                                          onClick={(event: any) => {
                                            event.stopPropagation();
                                          }}
                                          onChange={(
                                            event: any
                                          ) => {
                                            onSearchQueryChange(
                                              event.target.value
                                            );
                                          }}
                                          onKeyPress={(
                                            event: any
                                          ) => {
                                            onSearchQueryChange(
                                              event.target.value
                                            );
                                          }}
                                          placeholder="Search Course Name or SKU"
                                        />
                                      </Grid>
                                      
                                      {!activeChangeRequestTab && <Grid>
                                        <MyPATDropdown
                                            placeholder='Select Centre'
                                            dropdownItems={searchCenterList}
                                            selectedItem={[]}
                                            onChange={this.handleSelectedCenter}
                                            labelKey='name'
                                            valueKey='_id'
                                            multiple
                                            isCustomCss={true}
                                            enableSearch
                                            searchPlaceholder='Search Centre'
                                            handleSearch={this.handleCenterSearch}
                                            classes={{
                                              root: classes.checkBoxElement,
                                              checked: classes.checkedCheckbox,
                                              colorPrimary: classes.primaryColor,
                                            }}
                                        />
                                      </Grid>}
                                    </div>
                                  </Grid>
                                  <Grid item>
                                    <Grid
                                      style={{
                                        textAlign: "right",
                                      }}
                                    >
                                      <ContentPagination
                                        page={currentPageNo}
                                        count={totalCount}
                                        rowsPerPage={10}
                                        onChangePage={(
                                          e: any,
                                          page: number
                                        ) => {
                                          onPageChange(page);
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                              {activeTab === COURSES_TAB.COURSE_CHANGE_REQUEST &&
                                <ul className={classes.coursePlanChangeTab}>
                                  {COURSE_REQUEST_TABS.map((tab: string, tabIndex: number) =>
                                    <li className={cx({ 'current': this.state.currentTab === tabIndex })} onClick={() => this.handleTabClick(tabIndex)} key={tabIndex}><span>{tab} ({this.getRequestStatusCount(tabIndex)})</span></li>
                                  )}
                                </ul>
                              }
                              <Grid container>
                                <Grid item xs={12}>
                                  {packages &&
                                  packages.length > 0 ? (
                                    <CourseCardsList
                                      packages={packages}
                                        fromCourseRequestTab={activeChangeRequestTab}
                                    />
                                  ) : (
                                    <NoContent
                                      showCreateButton={
                                        searchQuery.length ===
                                          0 &&
                                        this.isFiltersEmpty(
                                          filters
                                        )
                                      }
                                    />
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      )}{" "}
                    </>
                    {/* {activeTab === COURSES_TAB.BULK_IMPORT && (
                      <>
                          <Grid item>
                                    <Grid
                                      style={{
                                        textAlign: "right",
                                        marginTop: 20
                                      }}
                                    >
                                      <ContentPagination
                                        page={currentReportPageNo}
                                        count={bulkReportCount}
                                        rowsPerPage={10}
                                        onChangePage={(
                                          e: any,
                                          page: number
                                        ) => {
                                          this.onPageChangeReport(page);
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                      <Grid item xs={12}>
                        <Paper className={classes.tableContainer}>
                          <Table className={`${classes.table} ${classes.bulkReportrow}`}>
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  {" "}
                                  <h3>S.No</h3>{" "}
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Operation Type</h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Initiated At</h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>
                                  Content Count 
                                  </h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>
                                    Total Courses
                                  </h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Processing Status</h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Completed At</h3>
                                </TableCell>
                                <TableCell align="center">
                                  <h3>Status</h3>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {bulkReport &&
                                bulkReport.map((ele: any, index: number) => {
                                  const initiateDate = moment(ele.createdAt).format('DD/MM/YYYY');
                                  const initiateTime = moment(ele.createdAt).format('hh:mm A');
                                  const completeDate = ele.completedAt && moment(ele.completedAt).format('DD/MM/YYYY');
                                  const completeTime = ele.completedAt && moment(ele.completedAt).format('hh:mm A');
                                  let progressPercent: any = 0;
                                  if(ele.totalProcessedCoursesCount && ele.totalProcessedCoursesCount >= 0) {
                                    progressPercent = ele.totalProcessedCoursesCount % ele.destinationCoursesCount !== 0 ? (((ele.totalProcessedCoursesCount / ele.destinationCoursesCount) * 100).toFixed(2)) : ((ele.totalProcessedCoursesCount / ele.destinationCoursesCount) * 100); 

                                  } else {
                                    progressPercent = 0;
                                  }
                                  return (
                                    <TableRow
                                      className={classes.row}
                                    >
                                      <TableCell
                                        component="th"
                                        scope="row"
                                      >
                                        {currentReportPageNo > 1 ? (((currentReportPageNo - 1)  * 10 ) + index + 1) : index + 1}
                                      </TableCell>
                                      <TableCell align="center">
                                        {this.getOperationType(ele.type)}
                                      </TableCell>
                                      <TableCell align="center">
                                        {initiateDate}, &nbsp;{initiateTime}
                                      </TableCell>
                                      <TableCell align="center">
                                        {ele.scheduleTestsCount}
                                      </TableCell>
                                      <TableCell align="center">
                                        {
                                          ele.destinationCoursesCount
                                        }
                                      </TableCell>
                                      <TableCell align="center">
                                        {ele.totalProcessedCoursesCount} ( <span className={classes.green}>{ele.successfulCoursesCount || 0}</span> <span className={classes.red}>{ele.failedCoursesCount || 0}</span> )
                                      </TableCell>
                                      <TableCell align="center">
                                      {ele.completedAt ? completeDate + ', ' + completeTime : '-' }
                                      </TableCell>
                                      <TableCell align="center" className={classes.textCapitalize}>
                                        <span>{ele.status === "inProgress" ? 'In Progress' : ele.status}</span>
                                        {ele.status !==
                                          "inProgress" && (
                                          <Typography className={classes.cursor} color="primary" onClick={() => this.getResponseSheet(ele._id, ele.type)}>
                                            Response Sheet
                                          </Typography>
                                        )}
                                        {
                                          ele.status === 
                                          "inProgress" && (
                                            <div className={classes.progressContainer}>
                                            <progress id="file" value={progressPercent} max="100"> {progressPercent}%</progress>
                                            <span> {progressPercent + '%'}</span>
                                            </div>
                                          )
                                        }
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                            </TableBody>
                          </Table>
                        </Paper>
                        
                      </Grid>
                      </>
                    )} */}
                  </Grid>
                </div>
              );
            }}
          </MyPATLandingContainer>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  bulkReport: state.courseMangementData.courseManagementReducer.bulkReport,
  bulkReportCount: state.courseMangementData.courseManagementReducer.bulkReportCount,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getActiveGoals,
      getBulkReport,
      resetAllState: contentManagementAction.resetAllState,
      setCoursePackageList: contentManagementAction.setCoursePackageList
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withRouter(withStyles(userStyles)(CourseManagementContainer)));

